<form [formGroup]="demoGroup" (ngSubmit)="sendRequest($event)" class="demo-form-panel">

  <div class="demo-form-panel__content" [ngClass]="{'demo-form-panel__content--col' : data.description.value}">

    <div>
      <div *ngIf="data.description.value" [innerHTML]="data.description.value | safe" #descriptionEl></div>
      <div class="demo-form-panel__link">
        <app-bg-button [data]="data.link.value" [buttonColor]="data.linkColor.value"></app-bg-button>
      </div>
    </div>

    <div class="demo-form-panel__form-holder">
      <h2 class="demo-form-panel__title" *ngIf="data.title" #titleEl>{{ data.title.value }}</h2>

      <div>
        <label>{{ formText.name }}</label>
        <input formControlName="name" type="text" class="demo-form-panel__form-holder--text" />
      </div>
      <div>
        <label>{{ formText.email }}</label>
        <input formControlName="email" type="text" class="demo-form-panel__form-holder--text" />
      </div>
      <div>
        <label>{{ formText.phone }}</label>
        <input formControlName="phone" type="tel" class="demo-form-panel__form-holder--text" />
      </div>
      <div>
        <label>{{ formText.company }}</label>
        <input formControlName="company" type="text" class="demo-form-panel__form-holder--text" />
      </div>
      <div class="demo-form-panel__form-holder--privacy-policy">
        <input type="checkbox" formControlName="privacyPolicy" />
        <p>{{'demoPanel.PrivacyPolicy.Label' | translate}} <a *ngIf="data?.cookiePolicyPageUrl" [routerLink]="data.cookiePolicyPageUrl" target="_blank">{{'demoPanel.PrivacyPolicy.Link' | translate}}</a></p>
      </div>
      <br />
      <re-captcha (resolved)="reCaptchaValidated($event)" #captcha="reCaptcha" siteKey="{{data.reCaptchaSecret}}"></re-captcha>
      <div class="demo-form-panel__form-holder--submit">
        <div *ngIf="errMsg" class="demo-form-panel__form-holder--error">{{ errMsg }}</div>
        <button type="button" (click)="sendRequest($event)" class="demo-form-panel__form-holder--link bg-green-button">{{ submitButton }}</button>
      </div>

    </div>

    <div *ngIf="requestSuccess === true" class="demo-form-panel__modal">
      <div class="demo-form-panel__modal--content">
        <p>{{ succMsg }}</p>
      </div>
    </div>

  </div>

</form>
